$(function () {
  $(".cart-custom--footer .cart-custom__agree input").on("click", function () {
    checkIsAgree();
  });

  function checkIsAgree() {
    if ($(".cart-custom--footer .cart-custom__agree input:checked").val()) {
      $(".cart-custom--footer .js-cart-checkout-button").addClass("is-active");
    } else {
      $(".cart-custom--footer .js-cart-checkout-button").removeClass("is-active");
    }
  }

  checkIsAgree();
});
